import { baseBUCGet } from '../base/baseBUC';

const str = '';
const decimal = 0.00;
const dateTimeStr = new Date()?.toISOString();

export const collectionCashMovementModelGet = ({
    buildingId = '',
    collectionCashId = '',
    type = '',
    userId = '',
}) => {
    return {
        collectionCashId: collectionCashId,
        amount: decimal,
        date: dateTimeStr,
        remark: str,
        type: type,
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};